/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Input } from '@angular/core';
import { Currency } from 'app/shared/enumeration/currency';
import { CurrencyUtils } from 'app/shared/helpers/currency-helpers';

@Component({
    selector: 'label-with-currency-inner-html',
    templateUrl: './label-with-currency-inner-html.component.html',
    standalone: false
})

///This component is designed to be used where a label is using the InnerHTML property with a currency symbol
///This is currently G&A specific with the use of Divisions and will need to be updated if used in other projects
export class LabelWithCurrencyInnerHtmlComponent {

    //An optional input for you to include a title with the currency symbol.
    @Input() title: number;
    //An optional input for you to include if the currency symbol should be a prefix or suffix, this is true by default.
    @Input() currencyIsSuffix: boolean = true;
    //An optional input for you to set the division id, this is Gapr by default which will set the symbol as (£).
    @Input() currency: Currency = Currency.GBP;
    //An optional input for you to include if the currency symbol should be in brackets, this is true by default.
    @Input() includeBrackets: boolean = true;

    currencySymbol(): string {
        let currencySymbol = CurrencyUtils.htmlEntity(this.currency);
        if (this.includeBrackets) {
            return '(' + currencySymbol + ')';
        }
        return currencySymbol;
    }

    textDisplay() {
        if (this.title && this.currencyIsSuffix) {
            return this.title + ' ' + this.currencySymbol();
        } else if (this.title && !this.currencyIsSuffix) {
            return this.currencySymbol() + ' ' + this.title;
        } else {
            return this.currencySymbol();
        }
    }

}